import(/* webpackMode: "eager" */ "/ai-news-brew/app/globals.css");
import(/* webpackMode: "eager" */ "/ai-news-brew/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/ai-news-brew/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/ai-news-brew/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/ai-news-brew/components/ui/tooltip.tsx")